import { render, staticRenderFns } from "./iconSIM.vue?vue&type=template&id=e1b44b48&scoped=true"
import script from "./iconSIM.vue?vue&type=script&lang=js"
export * from "./iconSIM.vue?vue&type=script&lang=js"
import style0 from "./iconSIM.vue?vue&type=style&index=0&id=e1b44b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b44b48",
  null
  
)

export default component.exports